var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-empty',{staticClass:"d-flex justify-center align-center flex-column max-height pa-10",attrs:{"id":"logout"}},[_c('base-loader',{attrs:{"type":"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }